import { Reveal } from "@/components/common/Reveal";

const pillars = [
  {
    title: "Positioning",
    text: "India's specialist agency for brands targeting the new generation of active Indians.",
  },
  {
    title: "Mission",
    text: "Connect brands with athletes, creators, IPs and communities through one integrated execution partner.",
  },
  {
    title: "Promise",
    text: "Not just an agency—your growth partner with end-to-end delivery and measurable outcomes.",
  },
];

export default function AboutPage() {
  return (
    <div className="mx-auto w-full max-w-7xl space-y-12 pb-16 sm:space-y-16" data-testid="about-page">
      <Reveal>
        <section className="rounded-3xl border border-blue-100/20 bg-card/70 p-7 sm:p-10" data-testid="about-intro-section">
          <p className="font-oswald text-xs uppercase tracking-[0.24em] text-accent" data-testid="about-intro-kicker">
            About Purnam
          </p>
          <h1 className="mt-4 font-oswald text-4xl uppercase leading-tight text-white sm:text-5xl" data-testid="about-main-heading">
            Growth Infrastructure For Sports, Wellness, And Culture Brands
          </h1>
          <p className="mt-6 max-w-4xl text-sm text-blue-100/90 sm:text-base" data-testid="about-main-description">
            Purnam Talent Management helps brands win in sport and wellness by combining athlete credibility,
            creator ecosystems, and execution discipline. We plan, activate, and optimise campaigns with clear
            business goals at the center.
          </p>
        </section>
      </Reveal>

      <section className="grid gap-6 md:grid-cols-12" data-testid="founder-story-section">
        <Reveal className="md:col-span-4" delay={0.05}>
          <p className="font-oswald text-xs uppercase tracking-[0.24em] text-primary" data-testid="founder-story-kicker">
            Why Athlete-Led Works
          </p>
          <h2 className="mt-4 font-oswald text-3xl uppercase text-white" data-testid="founder-story-title">
            Trust. Reach. Performance.
          </h2>
        </Reveal>

        <Reveal className="md:col-span-8" delay={0.12}>
          <div className="rounded-2xl border border-blue-100/20 bg-[#041748]/70 p-6 sm:p-8" data-testid="founder-story-content">
            <p className="text-sm leading-relaxed text-blue-100/88 sm:text-base" data-testid="founder-story-description">
              Athletes carry credibility that generic influencers can't replicate. With multi-sport, multi-city talent,
              brands get authentic reach and stronger conversion outcomes. We build campaigns that feel real, perform,
              and scale.
            </p>
          </div>
        </Reveal>
      </section>

      <section className="grid gap-5 md:grid-cols-3" data-testid="about-pillars-grid">
        {pillars.map((item, idx) => (
          <Reveal key={item.title} delay={idx * 0.08}>
            <article className="h-full rounded-2xl border border-blue-100/20 bg-card/75 p-6" data-testid={`pillar-card-${idx + 1}`}>
              <h3 className="font-oswald text-xl uppercase text-white" data-testid={`pillar-title-${idx + 1}`}>
                {item.title}
              </h3>
              <p className="mt-3 text-sm text-blue-100/85" data-testid={`pillar-text-${idx + 1}`}>
                {item.text}
              </p>
            </article>
          </Reveal>
        ))}
      </section>
    </div>
  );
}